import GenericError from './GenericError';

export const ClientBlocked = ({ clientName }: { clientName?: string }) => {
  const errorMessage = clientName
    ? `Please reach out to ${clientName} for more information.`
    : "Please reach out to the application you're integrating with for more information.";

  return (
    <GenericError title="Something went wrong">
      <p>{errorMessage}</p>
    </GenericError>
  );
};
